import { render } from "./CadastroArtEngenheiroTransportador.vue?vue&type=template&id=17687d09"
import script from "./CadastroArtEngenheiroTransportador.vue?vue&type=script&lang=ts"
export * from "./CadastroArtEngenheiroTransportador.vue?vue&type=script&lang=ts"
script.render = render

export default script